// Query params that name an actual chat-list filter, as opposed to the display-only `view`
// and `panels` prefs.
//
// A URL carrying any of these is treated as a complete filter definition: ChatList resets
// every filter the URL does NOT name to its default instead of inheriting it from the
// per-user `chatFilters_<userID>` cache, and that reset state is what gets written back to
// the cache. Without this a shared link like `/chat?unread=1` silently applies whatever tag
// or status filters the recipient happened to have left set, with nothing in the URL to say
// so — the query string is stripped on arrival.
//
// Kept in its own module (no imports) so the rule is unit-testable without pulling in
// ChatList's render dependencies.
export const FILTER_URL_PARAM_KEYS = [
    'open', 'closed', 'auto_closed', 'paused', 'not_paused',
    'unread', 'missing_info',
    'guest_msgs', 'guide_msgs', 'staff_msgs', 'ai_msgs', 'auto_msgs',
    'hide_active', 'hide_upcoming', 'hide_past',
    'needs_person',
    'order', 'itags', 'atags', 'xatags', 'ptags',
];

// `parsedUrlParams` is ChatList's parsed query string, where an absent param is `undefined`
// rather than omitted — so presence is what counts, not truthiness (`?open=0` is a filter).
export function urlDefinesFilters(parsedUrlParams) {
    return !!parsedUrlParams && FILTER_URL_PARAM_KEYS.some(k => parsedUrlParams[k] !== undefined);
}
